import { type ReactElement } from 'react';

import { Stack, Typography } from '@mui/material';

import { LearnMoreButton } from './LearnMoreButton';

export const RightPanel = (): ReactElement => {
  return (
    <Stack maxWidth={400} gap={2}>
      <Typography variant="title1" fontWeight="500">
        ChangeGPS
      </Typography>
      <Typography variant="bodySmall">
        Get ready to do what matters. Legendary frontline accounting apps that
        transform your practice and your working life.
      </Typography>
      <LearnMoreButton
        component="a"
        href="https://changegps.com.au"
        target="_blank"
        rel="noopener noreferrer"
      >
        Learn More
      </LearnMoreButton>
    </Stack>
  );
};
